import { ASSET_CLASS_IDS } from "~/consts";
import type { Props as AggregateDisplayProps } from "~/components/AggregateDisplay";
import { AggregateValueTypes } from "~/components/AggregateDisplay/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import type { Asset } from "../types";

// // // //

interface AssetApyConfig {
    label: "7D APY" | "30D APY";
    measureSlug: "apy_7_day" | "apy_30_day";
    changeField: "chg_7d_pct" | "chg_30d_pct";
    changeInterval: "7d" | "30d";
}

export function getAssetApyConfig(
    asset: Pick<Asset, "asset_class_id">,
): AssetApyConfig {
    if (asset.asset_class_id === ASSET_CLASS_IDS.TreasuryProduct) {
        return {
            label: "7D APY",
            measureSlug: "apy_7_day",
            changeField: "chg_7d_pct",
            changeInterval: "7d",
        };
    }

    return {
        label: "30D APY",
        measureSlug: "apy_30_day",
        changeField: "chg_30d_pct",
        changeInterval: "30d",
    };
}

export function hasAssetApyMeasure(asset: Asset): boolean {
    return getMeasureValue(asset, getAssetApyConfig(asset).measureSlug) != null;
}

export function getAssetApyAggregate(
    asset: Asset,
): AggregateDisplayProps | null {
    const config = getAssetApyConfig(asset);
    const apy = getMeasureValue(asset, config.measureSlug, 0);

    if (!apy || apy.val <= 0) {
        return null;
    }

    return {
        label: config.label,
        type: AggregateValueTypes.percent,
        value: apy.val / 100,
        percentChange: {
            value: apy[config.changeField] ?? 0,
            interval: config.changeInterval,
        },
    };
}
